import { useInfiniteQuery } from '@tanstack/react-query'
import { giftTypeService } from '../../../services/gifts/gift-types'
import { setGraphClientAuthToken } from '../../../services/graph-client'

export const GIFT_TYPES_QUERY_KEY = ['getGiftTypes']

export const useGetGiftTypes = (options?: { token?: string | null; enabled?: boolean }) => {
  const { data, isFetchingNextPage, isLoading, refetch, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [GIFT_TYPES_QUERY_KEY],
      staleTime: Infinity,
      retry: 1,
      initialPageParam: 0,
      queryFn: ({ pageParam: skip }) => {
        setGraphClientAuthToken(options?.token)
        return giftTypeService.get({ take: 20, skip, active: true })
      },
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        if (lastPage && !lastPage?.data?.length) {
          return null
        }

        if (lastPage?.error) {
          return null
        }

        return lastPageParam + 1
      },
    })

  return {
    giftTypes: data?.pages?.flatMap((page) => page?.data),
    isLoading,
    isFetchingNextPage,
    refetch,
    nextPage: fetchNextPage,
  }
}
